const ON_CHANGE_DEBOUNCE_TIMER = 300;
const RECENTLY_VIEWED_KEY = 'recently-viewed'; // 最近浏览
const FAV_PRODUCT_KEY = 'fav-product'; // 收藏

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update', // 购物车更新
  quantityUpdate: 'quantity-update', // 产品页面产品数量更新
  variantChange: 'variant-change', // 产品页面产品变体变化
  cartError: 'cart-error', // 购物车错误
};
